import { render, staticRenderFns } from "./PointCourse.vue?vue&type=template&id=7685d2b0&scoped=true&"
import script from "./PointCourse.vue?vue&type=script&lang=js&"
export * from "./PointCourse.vue?vue&type=script&lang=js&"
import style0 from "./PointCourse.vue?vue&type=style&index=0&id=7685d2b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7685d2b0",
  null
  
)

export default component.exports